import { COPY } from "../copy";

const REASON = COPY.shared.reorderNotApplicable;

/**
 * A column that doesn't apply to this row's ad type, in the cohort and Customers
 * tables.
 *
 * Gray rather than hatched like the month table's disabled cells: there, a whole
 * column switches off at once and the hatch reads as a state change across the
 * table. Here it alternates row by row with real figures, so a hatch would look
 * like damage.
 *
 * The reason rides along as a native title, the same quiet confirmation the month
 * table gives — it belongs to the ad type, not to each of dozens of cells.
 */
export function NotApplicableCell() {
  return (
    <span className="text-[#757575]" title={REASON} aria-label={REASON}>
      —
    </span>
  );
}
